import { useEffect, useState } from 'react'
import styles from './styles.module.scss'
import { Button } from '../../../../../ui'
import { Loading } from 'notiflix'
import { Report } from 'notiflix/build/notiflix-report-aio'
import { useNavigate } from 'react-router-dom'
import api from '../../../../../helpers/apiRequester'
import Select from 'react-select'
import { selectObjectProps } from '../../../../../interfaces'
import { feeEarners } from '../../../../../data'
// import { PocModalView } from "../../../pocModalView";
export interface statsProps {
    data: any
}

export const CaseDetailsView = (props: statsProps) => {
    const { data } = props
    const [editing, setEditing] = useState(false)
    const [hasCCData, setHasCCData] = useState(true)
    const [caseData, setCaseData] = useState(data)
    const [feeEarner, setFeeEarner] = useState(feeEarners.find((fe) => fe.value == data.fee_earner))
    const [dataChanged, setDataChanged] = useState(false)
    const [addPocModal, setAddPocModal] = useState(false)

    useEffect(() => {
        // console.log("CASE INFO DATAVIEW : ", data);
        setCaseData(data)
        console.log(data)
        setHasCCData(data.cc_policy_association == 'Success')
    }, [data])

    // useEffect(() => {
    //     // console.log("CASE INFO DATAVIEW : ", data);
    //     // setCaseData(data);
    //     console.log("case data: ", caseData);
    // }, [caseData]);

    const handleSubmit = (e: React.FormEvent<HTMLFormElement>) => {
        e.preventDefault()
    }

    const onChange = async (e: React.FormEvent<HTMLInputElement>) => {
        let tempCaseData = { ...caseData }
        tempCaseData[e.currentTarget.name] = e.currentTarget.value
        setCaseData(tempCaseData)
        setDataChanged(true)
    }

    const saveData = async () => {
        Loading.circle('Saving')
        setEditing(false)
        console.log('SAVE DATA......')
        try {
            const apiResult = await api({
                url: 'save-case-info',
                data: { caseDataToSave: caseData },
            })
            Loading.remove()
            if (!apiResult.data.success) return Report.failure('Error', 'An error occurred.', 'Okay')

            Report.success('Success', 'Your update saved successfully.', 'Okay')
        } catch (error) {
            Report.failure('Error', 'Couldnt save data.', 'Okay')
        }
    }
    const togglePocModal = (refresh: boolean | null = null) => {
        console.log('TOGGLING....refresh:', refresh)
        if (refresh) window.location.reload()
        setAddPocModal(!addPocModal)
    }

    const handleEditToggle = () => {
        if (editing) {
            setCaseData(data)
        }
        setEditing(!editing)
    }

    const onSelectChange = (option: selectObjectProps | null, label: string) => {
        console.log('input label: ', label)
        if (option != null) {
            console.log('INPUT SELECT FIELD CHANGED...', option.value)
            const updateItem = option.label
            const updateValue = option.value

            let tempCaseData = { ...caseData }
            tempCaseData.fee_earner = updateValue
            console.log('data to save : ', tempCaseData)

            setFeeEarner(feeEarners.find((fe) => fe.value == updateValue))
            setCaseData(tempCaseData)
            setDataChanged(true)
        }
    }

    return (
        <div className={styles.detailsView}>
            <h4>
                <span>Details</span>

                <span>
                    <Button size="sm" variant="neutral" onClick={() => handleEditToggle()}>{editing ? 'Cancel' : 'Edit'}</Button>
                    {editing && dataChanged ? (
                        <>
                            <Button size="sm" variant="primary" onClick={() => saveData()}>
                            Save
                        </Button>
                        </>
                    ) : (
                        <></>
                    )}
                </span>
            </h4>
            <div className={styles.viewContainer}>
                <form onSubmit={(e) => handleSubmit(e)}>
                    <fieldset>
                        <label>Base Claim</label>
                        <input
                            className={styles.textInput}
                            name={'case_ref'}
                            value={caseData.base_claim === 1 ? 'Yes' : 'No'}
                            type="text"
                            onChange={onChange}
                            disabled={true}
                        />
                    </fieldset>
                    <fieldset>
                        <label>Lender</label>
                        <input
                            className={styles.textInput}
                            name={'lender'}
                            value={caseData.lender}
                            type="text"
                            onChange={onChange}
                            disabled={!editing}
                        />
                    </fieldset>

                    <fieldset>
                        <label>Policy Number</label>
                        <input
                            className={styles.textInput}
                            name={'policy_number'}
                            value={caseData.policy_number}
                            type="text"
                            onChange={onChange}
                            disabled={!editing}
                        />
                    </fieldset>

                    <fieldset>
                        <label>Start Date</label>
                        <input
                            className={styles.textInput}
                            name={'start_date'}
                            value={caseData.start_date}
                            type="text"
                            onChange={onChange}
                            disabled={!editing}
                        />
                    </fieldset>

                    <hr style={{ width: '100%', marginLeft: 0, marginBottom: 20 }} />

                    <fieldset>
                        <label>Contract Length</label>
                        <input
                            className={styles.textInput}
                            name={'length_of_contract'}
                            value={caseData.length_of_contract}
                            type="text"
                            onChange={onChange}
                            disabled={!editing}
                        />
                    </fieldset>

                    <fieldset>
                        <label>Monthly Repayment</label>
                        <input
                            className={styles.textInput}
                            name={'monthly_repayment'}
                            value={caseData.monthly_repayment}
                            type="text"
                            onChange={onChange}
                            disabled={!editing}
                        />
                    </fieldset>

                    <fieldset>
                        <label>Total Amount Payable</label>
                        <input
                            className={styles.textInput}
                            name={'total_amount_payable'}
                            value={caseData.total_amount_payable}
                            type="text"
                            onChange={onChange}
                            disabled={!editing}
                        />
                    </fieldset>

                    <fieldset>
                        <label>Account Type</label>
                        <input
                            className={styles.textInput}
                            name={'account_type'}
                            value={caseData.account_type}
                            type="text"
                            onChange={onChange}
                            disabled={!editing}
                        />
                    </fieldset>

                    <fieldset>
                        <label>Lender Type</label>
                        <input
                            className={styles.textInput}
                            name={'lender_type'}
                            value={caseData.lender_type}
                            type="text"
                            onChange={onChange}
                            disabled={!editing}
                        />
                    </fieldset>

                    <fieldset>
                        <label>PDF Claim</label>
                        <input
                            className={styles.textInput}
                            name={'pdf_claim'}
                            value={caseData.pdf_claim}
                            type="text"
                            onChange={onChange}
                            disabled={!editing}
                        />
                    </fieldset>

                    <fieldset>
                        <label>Origin</label>
                        <input
                            className={styles.textInput}
                            name={'origin'}
                            value={caseData.origin}
                            type="text"
                            onChange={onChange}
                            disabled={!editing}
                        />
                    </fieldset>

                    <fieldset>
                        <label>Lead Source</label>
                        <input
                            className={styles.textInput}
                            name={'lead_source'}
                            value={caseData.lead_source}
                            type="text"
                            onChange={onChange}
                            disabled={!editing}
                        />
                    </fieldset>

                    <hr style={{ width: '100%', marginLeft: 0, marginBottom: 20 }} />

                    <fieldset>
                        <label>Created At</label>
                        <input
                            className={styles.textInput}
                            name={'created_at'}
                            value={new Date(caseData.created_at).toLocaleString()}
                            type="text"
                            onChange={onChange}
                            disabled={!editing}
                        />
                    </fieldset>

                    <fieldset>
                        <label>Updated At</label>
                        <input
                            className={styles.textInput}
                            name={'updated_at'}
                            value={new Date(caseData.updated_at).toLocaleString()}
                            type="text"
                            onChange={onChange}
                            disabled={!editing}
                        />
                    </fieldset>
                </form>
            </div>
        </div>
    )
}
